import Script from 'next/script'
import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { Cart, LineItem } from 'lib/hooks/use-cart'
import { currency } from 'lib/currency'
import _ from 'lodash'
import { ProductDetail, ProductVariant } from 'lib/hooks/use-products'
import { CollectionProducts } from 'lib/hooks/use-collections'
import { isDev } from 'constants/analytics'

interface TrackArgs {
    eventName: string
    properties?: any
    profileProperties?: any
    aliases?: string[]
    eventID?: string
    timestamp?: number
    reject?: ( e: unknown ) => void
    resolve?: ( data: unknown ) => void
}


export const cvgTrack = ( args: TrackArgs ) => {
	if ( typeof window === 'undefined' ) return
	let cvg: any = window[ 'cvg' ]
	if ( !cvg ) cvg = window[ 'cvg' ] = function( ...args ) {
		cvg.queue = cvg.queue || []
		if ( cvg.process ) cvg.process.bind( cvg )( ...args )
		else cvg.queue.push( args )
	}
	cvg({ method: 'track', ...args })
}

export const parseProduct = (
	product: ProductDetail, variant: ProductVariant 
) => ({
	product_id: product.id.split( '/' ).pop(),
	variant_id: variant.id.split( '/' ).pop(),
	name: product.title,
	variant_name: variant.title,
	price: Number( variant.priceV2.amount ),
	currency: currency.code,
})

export const parseCollection = ( collection: CollectionProducts ) => ({
	id: collection.id.split( '/' ).pop(),
	name: collection.title,
	items: collection.products.map( product => ({
		product_id: product.id.split( '/' ).pop(),
		variant_id: product.variants[ 0 ]?.id.split( '/' ).pop(),
		name: product.title,
		variant_name: product.variants[ 0 ]?.title,
		price: Number( product.prices[ 0 ] ),
		currency: currency.code,
	}) ),
})

export const parseLineItem = ( item: LineItem ) => ({
	product_id: item.variant.product.id.split( '/' ).pop(),
	variant_id: item.variant.id.split( '/' ).pop(),
	name: item.variant.product.title,
	variant_name: item.variant.title,
	price: Number( item.variant.priceV2.amount ),
	quantity: item.quantity,
	discount: (
		item.variant.compareAtPrice
			? Number( item.variant.compareAtPrice.amount )
            - Number( item.variant.priceV2.amount )
			: 0
	),
	currency: currency.code,
})

export const parseCart = ( cart: Cart ) => ({
	id: cart.id.split( '/' ).pop(),
	items: cart.lineItems.map( parseLineItem ),
	total_price: Number( cart.lineItemsSubtotalPrice.amount ),
	total_discount: _.sum(
		cart.lineItems.map( ( l ) => (
			l.variant.compareAtPrice
				? Number( l.variant.compareAtPrice.amount )
						- Number( l.variant.priceV2.amount )
				: 0
		) ) 
	),
	currency: currency.code,
})

export function Converge() {
	if ( isDev() ) return null

	const { pathname } = useRouter()

	useEffect( () => {
		cvgTrack({ eventName: '$page_load' })
	}, [ pathname ] )
    
	return <Script src="https://static.runconverge.com/pixels/PiDaO3.js" async />
}
